import { useEffect, useState } from "react";
import axios from "axios";

export default function User_data() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("token");

    axios.get(`/api/user/me`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => setUser(res.data))
      .catch(err => console.error(err));
  }, []);

  if (!user) {
    return (
      <div className="text-center mt-5 text-white fw-light">
        Loading profile...
      </div>
    );
  }

  const initials = user.ime
    ? user.ime.split(" ").map(word => word[0]).join("").toUpperCase()
    : "U";

  return (
    <div className="container mt-5">
      <div
        className="p-5 rounded-4 shadow-lg"
        style={{
          background: "rgba(255,255,255,0.03)",
          backdropFilter: "blur(20px)",
          border: "1px solid rgba(255,255,255,0.08)",
          color: "#fff"
        }}
      >

        {/* HEADER */}
        <div className="d-flex align-items-center mb-5">

          {/* Avatar */}
          <div
            className="rounded-circle d-flex align-items-center justify-content-center me-4"
            style={{
              width: "90px",
              height: "90px",
              fontSize: "30px",
              fontWeight: "600",
              color: "#fff",
              background: "linear-gradient(135deg, #4f46e5, #9333ea)",
              boxShadow: "0 10px 30px rgba(147,51,234,0.4)"
            }}
          >
            {initials}
          </div>

          {/* Name + Role */}
          <div>
            <h2 className="mb-2 fw-semibold" style={{ color: "#fff" }}>
              {user.ime}
            </h2>

            <span
              className="px-3 py-1 rounded-pill"
              style={{
                fontSize: "13px",
                fontWeight: "500",
                letterSpacing: "1px",
                background:
                  user.uloga === "admin"
                    ? "linear-gradient(135deg,#ef4444,#b91c1c)"
                    : "linear-gradient(135deg,#2563eb,#1d4ed8)",
                color: "#fff"
              }}
            >
              {user.uloga.toUpperCase()}
            </span>
          </div>
        </div>

                {/* INFO LIST */}
        <div className="mt-4">

          {[
            { label: "User ID", value: user.klijentID },
            { label: "Email Address", value: user.email },
            { label: "Adresa", value: user.adresa },
            { label: "Grad", value: user.grad },
            { label: "Telefon", value: user.telefon }
          ].map((item, index) => (
            <div
              key={index}
              className="d-flex justify-content-between align-items-center p-4 mb-3 rounded-3"
              style={{
                background: "rgba(255,255,255,0.04)",
                border: "1px solid rgba(255,255,255,0.06)",
                transition: "all 0.3s ease"
              }}
              onMouseEnter={e => {
                e.currentTarget.style.background = "rgba(255,255,255,0.07)";
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow = "0 10px 25px rgba(0,0,0,0.4)";
              }}
              onMouseLeave={e => {
                e.currentTarget.style.background = "rgba(255,255,255,0.04)";
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "none";
              }}
            >
              <span
                style={{
                  color: "rgba(255,255,255,0.6)",
                  fontSize: "14px",
                  letterSpacing: "0.5px"
                }}
              >
                {item.label}
              </span>

              <span
                style={{
                  color: "#fff",
                  fontWeight: "500",
                  fontSize: "16px"
                }}
              >
                {item.value || "-"}
              </span>
            </div>
          ))}

        </div>

      </div>
    </div>
  );
}